import { createApp } from 'vue'

import dayjs from 'dayjs'
import dayjsZhCn from 'dayjs/locale/zh-cn'
import App from 'src/App.vue'
import 'src/assets/svg/index'
import FilterPlugin from 'src/filter'
import router from 'src/router'
import store from 'src/store'
import VueLazyLoad from 'vue3-lazyload'
import errorImg from './assets/image/empty-image.png'
import loadingImg from './assets/image/loading.gif'
import AuthPlugin from './plugins/auth'
import './plugins/axios'
import GlobalPlugin from './plugins/global'
import './styles/index.scss'
import '@baibao/zeratul/dist/style.css'
import { autoFocus, blur } from '@/directives'

dayjs.locale(dayjsZhCn)

const app = createApp(App)

app.use(FilterPlugin)
app.use(GlobalPlugin)
app.use(AuthPlugin)
app.use(VueLazyLoad, {
  error: errorImg,
  loading: loadingImg,
})
app.use(router)
app.use(store)

app.directive('focus', autoFocus)
app.directive('blur', blur)

app.config.globalProperties.$router = router
app.config.globalProperties.$store = store
window.$router = router
window.$store = store

app.mount('#app')
